<template>
  <div class="agree-content marketing">
    본 웹사이트(이하 "웹사이트")는 Bayer AG(이하 “당사” 또는 “저희”)에서 제공합니다. 웹사이트 제공자에 대한 자세한 내용은 당사 발행자명을 참조하십시오.<br />
    <br />
    바이엘은 다음에 열거된 목적들을 위하여 개인정보를 수집∙이용하며, 바이엘 및 바이엘의 수탁자가 처리하는 개인정보는 다음의 목적 이외의 용도로는 이용되지 않으며, 이용목적이 변경되는 경우 개인정보보호법에 따라
    별도의 동의를 받는 등 필요한 조치를 취할 예정입니다. 바이엘은 관계법령 및 내부 규정상 보존의무가 없는 한 수집한 이용자의 개인정보를 원칙적으로 명시하여 동의받은 수집 및 이용목적, 이용기간내에서만 제한적으로
    이용하고 있으며, 해당 이용자가 탈퇴를 요청하거나 동의를 철회하는 경우 지체없이 파기합니다.

    <br />
    <br />
    <ul>
      <li>개인정보의 수집 항목 및 이용 목적</li>
    </ul>
    <br />
    “회사“는 다음과 같이 “회원“의 개인정보를 수집하고 있습니다. 단, “회원“의 기본적 인권 침해의 우려가 있는 민감한 개인정보(인종 및 민족, 사상 및 신조, 출신지 및 본적지, 정치적 성향 및 범죄기록,
    건강상태 및 성생활 등)와 주민등록번호는 법령상 근거 없이 불필요하게 수집하지 않습니다.<br />
    <br />
    개인정보의 수집 항목을 구분, 수집항목, 이용 목적으로 나타낸 표입니다.<br />
    <br />

    <table border="1">
      <tr>
        <td>구분</td>
        <td>수집 항목</td>
        <td>수집 목적</td>
      </tr>
      <tr>
        <td>필수</td>
        <td>이름, 비밀번호, 연령대, 자택주소, 주요재배작물과 재배면적</td>
        <td>
          - 멤버십 서비스 제공 <br />
          - 서비스 이용을 위한 본익식별 및 확인<br />
          - 회원에 대한 고지사항 전달<br />
          - 통합 ID 관리<br />
          - 경품 및 제품 배송<br />
          - 고객센터 운영<br />
          - 불량회원 부정이용 방지 및 비인가 사용 방지<br />
          - VIP 서비스 제공<br />
        </td>
      </tr>
      <tr>
        <td></td>
        <td> 이름, 생년월일, 성별, 카카오계정(휴대전화번호), 카카오톡 채널 추가 상태 및 내역</td>
        <td>카카오 간편회원 가입 서비스 제공</td>
      </tr>
      <tr>
        <td>선택</td>
        <td>이메일주소, 소속단체명, 사용중인 바이엘 제품명, 농약 주요 구매</td>
        <td>사은/판촉행사 등 각종 이벤트, 행사 관련 정보안내 및 제반 마케팅 활동, 당사 및 제휴사 상품/서비스 안내 및 권유</td>
      </tr>
      <tr>
        <td>서비스 이용 또는 사업처리 과정에서 생성/수집되는 정보</td>
        <td>
          - 서비스 이용기록(이용 시간/이용매장/포인트/상품 또는 서비스 구매내역) 및 결제기록, 접속 IP 정보, 쿠키(Cookie), 광고식별자(ADID/IDFA) 등<br />
          - 단말기기정보(모델명, OS, IDFV, OS버전, 앱버전, 시스템 설정 상 알림 차단 여부, 국가정보, 앱 삭제 여부 등), 단말접속일시, PUSH토큰 등
        </td>
        <td>
          - 분쟁 조정을 위한 기록보존<br />
          - 혜택 및 서비스 개발을 위한 통계분석 및 연구조사<br />
          - 실시간 메시징 서비스, 고객 활동 정보 수집 및 분석

        </td>
      </tr>
    </table>

    <p>
      만 14세 미만 아동은 회원가입이 불가합니다.<br />
      <br />
    <ul>
      <li>개인정보의 수집방법</li>
    </ul>
    <br />
    당사는 다음의 각 호와 같은 방법으로 개인정보를 수집합니다.<br />
    1) 홈페이지(PC/모바일)<br />
    2) 영업사원 및 고객센터 상담 이용<br />
    3) 제휴사로부터의 제공<br />
    4) 로그 분석 프로그램을 통한 생성 정보 수집<br />
    5) '쿠키(cookie)'에 의한 정보 수집<br />

    <br />
    당사와 독일 내 모든 당사 자회사가 웹사이트 이외의 기타 선택된 항목과 관련된 데이터 처리 활동을 수행하는 것(예: 귀하가 당사에 명함을 주거나 당사가 일반에 공개된 출처에서 귀하의 데이터를 수집하는 경우)과
    관련된 정보는 선택된 특정 처리 활동에 대한 개인정보 보호 정보에서 확인할 수 있습니다.<br />
    <br />
    Bayer이 활동 중인 특정 국가 및/또는 지역의 개인정보 보호에 대한 보충 정보도 제공됩니다. 특정 국가 및/또는 지역의 개인정보 보호에 대한 추가 정보는 제공된 지역별 개인정보 보호정책 리스트
    <a href="https://www.bayer.com/ko/privacy-statement" target="_blank">https://www.bayer.com/ko/privacy-statement</a>를
    참고해 주시기 바랍니다.

    </p>













  </div>
</template>

<script>
export default {};
</script>

<style lang="scss">
.marketing {

  table,
  th,
  td {
    border: 1px solid black;
    border-collapse: collapse;
  }
}
</style>